import { watch } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { $axios, $queryClient } from '@/boot/initApi'

export default ({ atcs }) => ({
  flatAtcs: ({ enabled = true } = {}) => {
    const query = useQuery({
      queryKey: ['atcs'],
      queryFn: async () => {
        try {
          const { data } = await $axios.get('api/atcs/flat')
          return data
        } catch (err) {
          console.error(err)
          return { data: [] }
        }
      },
      enabled,
      staleTime: Infinity
    }, $queryClient)

    watch(query.data, val => {
      if (val) atcs.value = val.data
    }, { immediate: true })

    return query
  }
})
